import script from "./technician_log.vue?vue&type=script&setup=true&lang=js"
export * from "./technician_log.vue?vue&type=script&setup=true&lang=js"

import "./technician_log.vue?vue&type=style&index=0&id=b249b398&lang=css"

const __exports__ = script;

export default __exports__